module.exports = __webpack_public_path__ + "static/img/logo_30.3a1c417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_30.png
// module id = aj0Y
// module chunks = 1